<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-10 offset-md-1 text-center">
                    <div class="wrap-block6">
                        <h1>Over Recruitment Accelerator</h1><br/>

                        <p>Recruitment Accelerator deelt haar kennis, ervaring over recruitment en
                            arbeidsmarktcommunicatie graag. In de gedeelde passie voor recruitment, data en innovatie is
                            het idee van Recruitment Accelerator ontstaan. Onze ambitie is: volledig ontzorgen van HR en
                            vacaturehouder/management, het sterk verkorten van de tijd tussen het ontstaan van een
                            vacature en de ontvangst van passende sollicitaties, ontsluiting van lastig te werven
                            doelgroepen, het behalen van resultaat tegen normale kosten en plezier hebben in werven.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
  export default {
    name: 'about_us',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    h1, h2 {
        font-weight: normal;
        color: white;
    }

    h4 {
        color: white;
    }

    p {
        color: white;
    }

    .wrap-block6 {
        padding-top: 40px;
    }
</style>
